var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck70 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 70,
  viewBox: "0 0 70 70",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.8025 9.10195C64.0224 9.26904 64.0652 9.58271 63.8981 9.80257L25.8981 59.8026C25.8107 59.9175 25.6779 59.9891 25.5339 59.9989C25.3898 60.0087 25.2485 59.9557 25.1464 59.8536L7.14645 41.8536C6.95118 41.6583 6.95118 41.3417 7.14645 41.1465C7.34171 40.9512 7.65829 40.9512 7.85355 41.1465L25.4485 58.7414L63.1019 9.19749C63.269 8.97763 63.5827 8.93486 63.8025 9.10195Z",
  fill: "currentColor"
})));
export default SvgCheck70;